import { lazy } from 'react';

export const SignUpViaEmailPageLazy = lazy(
    () => import('./sign-up-via-email-page'),
);
